import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useLocation } from "react-router";
import { PropallyLpApiFactory } from "src/api/apiFactory";
import { useApiErrorHandler } from "src/hooks/api-error";
import { FormValues } from "src/hooks/form";

const fp = PropallyLpApiFactory();

export const useResultPage = () => {
  const location = useLocation();
  const { getValues } = useFormContext<FormValues>();
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => setModalOpen(false);

  const resultData = location.state?.result || {};

  const formData = getValues();

  const assessmentId = resultData.id;

  const { submitPreciseAssessment } = usePreciseAssessmentSubmit({
    onSuccess: () => setModalOpen(true),
  });

  const buildingName = formData.building_name;

  // 万円単位に変換（小数点以下切り捨て）
  const estimatedPriceInMan = Math.floor(resultData.estimated_price * 100);
  const errorMarginInMan = Math.floor(resultData.error_margin / 10000);

  // 数値をカンマ区切りの文字列に変換する関数
  const formatPrice = (price: number) => {
    return price.toLocaleString();
  };

  const minPrice = formatPrice(estimatedPriceInMan - errorMarginInMan);
  const maxPrice = formatPrice(estimatedPriceInMan + errorMarginInMan);

  return {
    buildingName,
    minPrice,
    maxPrice,
    submitPreciseAssessment: () => submitPreciseAssessment(assessmentId),
    modalOpen,
    closeModal,
  };
};

// 精密査定依頼API呼び出し用カスタムフック
const usePreciseAssessmentSubmit = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  // const { getValues } = useFormContext<FormValues>();
  const [sending, setSending] = useState<boolean>(false);
  const { error, clearError, handleError } = useApiErrorHandler();

  const submitPreciseAssessment = async (assessmentId: number) => {
    try {
      clearError();
      setSending(true);

      await fp.lpV1AiAssessmentsAssessmentIdPatch(assessmentId);

      onSuccess();
    } catch (error) {
      return handleError(error);
    } finally {
      setSending(false);
    }
  };

  return {
    sending,
    submitPreciseAssessment,
    error,
    clearError,
  };
};

export default usePreciseAssessmentSubmit;
